(function(){
	var browserRefs = ['google', 'bing'],
		$build = $('[data-alt-build]'),
		$anchors = $('[data-bi-download-name]');
		getReferrer = function () {
			var referrer = document.referrer;
			var path = referrer.split('/').filter(function (val) {
				return val.trim();
			});

			if (path.length > 1) {
				referrer = path[1];
			}

			if (referrer.length === 0) {
				return false;
			}

			return referrer;
		},
		validateReferrer = function (referrer) {
			var isValid = false;

			if (referrer) {
				$.each(browserRefs, function(key, el){
					if (referrer.indexOf(el) > -1) {
						isValid = true;
					}
				});
			}

			return isValid;
		},
		hasUTMs = function () {
			var url = window.location.href;
			if (url.indexOf('utm_campaign') > -1 || url.indexOf('GCLID') > -1) {
				return true;
			} else {
				return false;
			}
		};

	var referrer = getReferrer();

	if (validateReferrer(referrer) && !hasUTMs()) {
		if ($anchors.length > 0 && $build.length > 0) {
			var build = $build.data('alt-build');

			$anchors.each(function(key, el){
				var oldBuild = $(el).data('bi-download-name');
				var href = $(el).attr('href').replace(oldBuild, build);

				$(el).attr('href', href);
				$(el).attr('data-bi-download-name', build);
			});
		}
	}

})();


var sliderMyCarousel = tns({
	container: '.slider-win8-av-reviews',
	controlsContainer: '.slider-win8-av-reviews-controls',
	controlsPosition: 'bottom',
	controls: false,
	navPosition: 'bottom',
	mouseDrag: true,
	speed: 400,
	fixedWidth: 304,
	preventScrollOnTouch: 'auto',
	responsive: {
		576: {
			center: true
		},
		768: {
			items: 2,
			slideBy: 2,
			controls: true,
			center: false
		},
		1280: {
			fixedWidth: 408
		},
		1366: {
			fixedWidth: 436
		},
		1600: {
			fixedWidth: 464
		}
	}
});
